import React from "react";

function isImageMime(m) {
  const t = String(m || "").toLowerCase();
  return t.startsWith("image/");
}

export default function MessageBubble({
  message,
  isOwn,
  isGroupChat,
  senderName,
  senderAvatar,
  timestamp,
  showGif,
  bubbleSurfaceClass,
}) {
  const attachments = Array.isArray(message?.attachments) ? message.attachments : [];
  const hasAttachments = attachments.length > 0;
  const bodyText = String(message?.message || "").trim();
  const showLegacyGif = !hasAttachments && showGif;

  return (
    <div className={`flex w-full ${isOwn ? "justify-end" : "justify-start"}`}>
      <div className="w-fit max-w-[70%]">
        {isGroupChat && !isOwn && (
          <div className="flex items-center gap-2 mb-1.5 px-1">
            {senderAvatar ? (
              <img src={senderAvatar} alt={senderName} className="w-5 h-5 rounded-full border border-white/10" />
            ) : (
              <div className="w-5 h-5 rounded-full bg-white/10 border border-white/10 grid place-items-center text-[10px] text-white/70">
                {senderName[0]?.toUpperCase()}
              </div>
            )}
            <span className="text-[11px] font-medium text-white/70">{senderName}</span>
          </div>
        )}

        <div
          className={[
            "inline-block w-fit max-w-full rounded-[22px] border shadow-[0_12px_34px_rgba(0,0,0,0.24)]",
            hasAttachments || showLegacyGif ? "px-2 py-2" : "px-3 py-2",
            bubbleSurfaceClass ||
              (isOwn
                ? "bg-[#1a2b3a] border-[#355268] text-white"
                : "bg-[#121b2a] border-white/10 text-white/95"),
          ].join(" ")}
        >
          {hasAttachments && (
            <div className="flex flex-col gap-2 min-w-0">
              {attachments.map((att) => {
                const url = String(att?.public_url || "").trim();
                if (!url) return null;
                const mime = att?.mime_type;
                if (mime && !isImageMime(mime)) {
                  return (
                    <a
                      key={att.id || url}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[13px] underline break-all text-left"
                    >
                      Attachment
                    </a>
                  );
                }
                return (
                  <div key={att.id || url} className="flex justify-center min-w-0">
                    <div className="w-[240px] sm:w-[300px] max-w-full rounded-2xl bg-black/35 p-1.5 border border-white/15">
                      <img
                        src={url}
                        alt=""
                        className="w-full rounded-xl object-cover shadow-[0_12px_30px_rgba(0,0,0,0.45)] max-h-[360px]"
                        loading="lazy"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {showLegacyGif ? (
            <div className="flex justify-center">
              <div className="w-[240px] sm:w-[300px] rounded-2xl bg-black/35 p-1.5 border border-white/15">
                <img
                  src={String(message?.message || "").trim()}
                  alt="GIF"
                  className="w-full rounded-xl object-cover shadow-[0_12px_30px_rgba(0,0,0,0.45)]"
                  loading="lazy"
                />
              </div>
            </div>
          ) : null}

          {!showLegacyGif && bodyText ? (
            <div
              className={`text-[14px] leading-normal break-words whitespace-pre-wrap text-left ${
                hasAttachments ? "mt-2 px-1" : ""
              }`}
            >
              {message?.message || ""}
            </div>
          ) : null}
        </div>

        <div
          className={`mt-1.5 px-1.5 text-[11px] leading-none ${
            isOwn ? "text-[#a8c4d8]/62 text-right" : "text-white/40 text-left"
          }`}
        >
          {timestamp}
        </div>
      </div>
    </div>
  );
}
